const DEFAULT_SORT = 'impact';

export function filterInjuryReportPlayers(players, filters) {
	if (!players?.length) return [];

	let rows = players;

	if (filters.position) {
		const position = filters.position.toLowerCase();
		rows = rows.filter((row) => row.position?.toLowerCase() === position);
	}

	if (filters.team) {
		rows = rows.filter((row) => row.team?.name === filters.team);
	}

	if (filters.status_bucket) {
		const bucket = filters.status_bucket.toLowerCase();
		rows = rows.filter((row) => row.status_bucket === bucket);
	}

	const query = (filters.search || '').toLowerCase().trim();
	if (query) {
		rows = rows.filter((row) => {
			const fullName = `${row.first_name || ''} ${row.last_name || ''}`.toLowerCase();
			return (
				fullName.includes(query) ||
				(row.injury_description || '').toLowerCase().includes(query) ||
				(row.status || '').toLowerCase().includes(query)
			);
		});
	}

	return rows;
}

function rankSortKey(row) {
	const rank = row.fantasy_fitness_grade_position_rank;
	return rank != null && rank > 0 ? rank : 9999;
}

function nameSortKey(row) {
	return `${row.last_name || ''} ${row.first_name || ''}`.toLowerCase();
}

export function sortInjuryReportPlayers(players, sort = DEFAULT_SORT) {
	const rows = [...players];

	switch (sort) {
		case 'severity':
			return rows.sort(
				(a, b) =>
					b.severity_score - a.severity_score ||
					nameSortKey(a).localeCompare(nameSortKey(b))
			);
		case 'name':
			return rows.sort((a, b) => nameSortKey(a).localeCompare(nameSortKey(b)));
		case 'rank':
			return rows.sort((a, b) => {
				const rankDiff = rankSortKey(a) - rankSortKey(b);
				if (rankDiff !== 0) return rankDiff;
				return b.impact_score - a.impact_score || nameSortKey(a).localeCompare(nameSortKey(b));
			});
		case 'impact':
		default:
			return rows.sort((a, b) => {
				const impactDiff = b.impact_score - a.impact_score;
				if (impactDiff !== 0) return impactDiff;
				const rankDiff = rankSortKey(a) - rankSortKey(b);
				if (rankDiff !== 0) return rankDiff;
				return nameSortKey(a).localeCompare(nameSortKey(b));
			});
	}
}

export function applyInjuryReportClientFilters(players, filters) {
	return sortInjuryReportPlayers(filterInjuryReportPlayers(players, filters), filters.sort);
}
